// This file is automatically generated. Do not edit manually.

import { CustomerOrder } from "src/api/generated/erp/db/types/tables/customerOrder";
import { CustomerOrderSummary } from "src/api/generated/erp/sales/customerOrder/service/customerOrderSummary";
import { CustomerOrderLineView } from "src/api/generated/erp/db/types/tables/customerOrderLineView";
import { AcquisitionMethod } from "src/api/generated/erp/db/types/enums/acquisitionMethod";
import { IsoDateTimeString } from "src/types/dateTime";
import { CustomerOrderLineState } from "src/api/generated/erp/db/types/enums/customerOrderLineState";
import { CustomerOrderLineViewCustomerOrderState } from "src/api/generated/erp/db/types/enums/customerOrderLineViewCustomerOrderState";
import { IsoDateString } from "src/types/dateTime";
import { PurchaseOrderLineState } from "src/api/generated/erp/db/types/enums/purchaseOrderLineState";
import { SalesPartType } from "src/api/generated/erp/db/types/enums/salesPartType";
import { ShopOrderState } from "src/api/generated/erp/db/types/enums/shopOrderState";
import { CustomerOrderLineViewSourceType } from "src/api/generated/erp/db/types/enums/customerOrderLineViewSourceType";
import { makeAxiosRequest } from "src/api/utils/apiClient";

export namespace CustomerOrderLineDataGridApi {
	export async function getData(args: {
		customerOrderId: number;
		parentLineId: number | null | undefined;
		searchQuery?: string;
		showCancelledLines: boolean;
	}): Promise<CustomerOrderLineDataGridApi_Data> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/sales/customerOrderLine/dataGrid/getData",
			method: "POST",
			data: {
				customerOrderId: args.customerOrderId,
				parentLineId: args.parentLineId,
				searchQuery: args.searchQuery,
				showCancelledLines: args.showCancelledLines,
			},
		});
		return response as CustomerOrderLineDataGridApi_Data;
	}
}

export interface CustomerOrderLineDataGridApi_Data {
	customerOrder: CustomerOrder;
	customerOrderLines: Array<CustomerOrderLineDataGridApi_CustomerOrderLineDto>;
	customerOrderSummary: CustomerOrderSummary;
}

export interface CustomerOrderLineDataGridApi_CustomerOrderLineDto {
	childLines: Array<CustomerOrderLineView>;
	acquisitionMethod: AcquisitionMethod;
	automaticDelivery: boolean;
	billingPlanEnabled: boolean;
	cancelledDate: IsoDateTimeString | null | undefined;
	capacityQuantity: number;
	configurationContentHash: string | null | undefined;
	configurationOrPartDescription: string;
	configurationUnpackedAt: IsoDateTimeString | null | undefined;
	contactEmail: string;
	contactName: string;
	costLocked: boolean;
	createdAt: IsoDateTimeString;
	createdByUserId: number;
	currencyCode: string;
	currencyId: number;
	customerGroupId: number | null | undefined;
	customerId: number;
	customerName: string;
	customerOrderId: number;
	customerOrderIsCapacityReservation: boolean;
	customerOrderLineId: number;
	customerOrderLineLongName: string | null | undefined;
	customerOrderLineState: CustomerOrderLineState;
	customerOrderState: CustomerOrderLineViewCustomerOrderState;
	customerOrderTenantState: string | null | undefined;
	customerOrderTypeId: number;
	customerOrderTypeName: string;
	customerPoNo: string;
	customerPriceGroupId: number | null | undefined;
	defaultProductionLineId: number | null | undefined;
	defaultProductionLineName: string | null | undefined;
	deliveredQuantity: number;
	deliveryDate: IsoDateTimeString | null | undefined;
	discountFactor: number;
	discountPercentage: number;
	domesticCurrencyCode: string;
	domesticCurrencyId: number;
	externalId: string;
	invoicedQuantity: number;
	isAwaitingConfiguration: boolean;
	lastPickingDate: IsoDateString | null | undefined;
	lastShippingDate: IsoDateString | null | undefined;
	lastUpdated: IsoDateTimeString;
	lineNumber: number;
	mark: string;
	markedToFullyDelivered: boolean;
	orderReference: string;
	parentLineDescription: string | null | undefined;
	parentLineId: number | null | undefined;
	partAggregateOnShopOrder: boolean;
	partCategory: string | null | undefined;
	partConfigurationDescription: string | null | undefined;
	partConfigurationId: number | null | undefined;
	partConfigurationSelectedFromStock: boolean;
	partConfigurationWeight: number | null | undefined;
	partDefaultProductionLineId: number | null | undefined;
	partDescription_1: string | null | undefined;
	partDescription_2: string | null | undefined;
	partId: number | null | undefined;
	partIsConfigurable: boolean | null | undefined;
	partNo: string | null | undefined;
	partRemark: string | null | undefined;
	partUnit: string | null | undefined;
	partUnitId: number | null | undefined;
	partWeight: number | null | undefined;
	pickedQuantity: number;
	plannedDeliveryDate: IsoDateString;
	priceFactor: number;
	priceInputWithVat: boolean;
	priceLocked: boolean;
	priceUnitFactor: number;
	purchaseOrderId: number | null | undefined;
	purchaseOrderLineId: number | null | undefined;
	purchaseOrderLineState: PurchaseOrderLineState | null | undefined;
	purchaseUnit: string | null | undefined;
	releaseDate: IsoDateTimeString | null | undefined;
	reservedQuantity: number;
	salesPartCategoryId: number | null | undefined;
	salesPartDescription: string;
	salesPartId: number;
	salesPartNo: string;
	salesPartSalesPrice: number;
	salesPartType: SalesPartType;
	salesPriceUnit: string;
	salesPriceUnitId: number;
	salesQuantityAsPriceUnits: number;
	salesQuantityAsSalesUnits: number;
	salesQuantityAsWarehouseUnits: number;
	salesUnit: string;
	salesUnitFactor: number;
	salesUnitId: number;
	salespersonId: number | null | undefined;
	shopOrderBatchCode: string | null | undefined;
	shopOrderId: number | null | undefined;
	shopOrderProductionLineId: number | null | undefined;
	shopOrderState: ShopOrderState | null | undefined;
	siteId: number;
	siteName: string;
	sitePartCategoryId: number | null | undefined;
	sourceId: number | null | undefined;
	sourceType: CustomerOrderLineViewSourceType;
	totalCost: number;
	totalPrice: number | null | undefined;
	totalPriceWithVat: number | null | undefined;
	unitCost: number;
	unitPrice: number;
	unitPriceWithVat: number;
	vatCodeId: number;
	vatCodeName: string;
	vatHandlingTypeId: number;
	vatPercent: number;
	vatPercentFactor: number | null | undefined;
}
